import React, { useEffect, useState } from 'react';
import client from '../../../utils/prismicHelpers';
import * as queries from "../../../utils/prismicQueries";
import './innoProgram.css'
import AcademicCommoncrd from '../AcademicCommoncrd/AcademicCommoncrd';
import ImportantDate from './ImportantDate';
import AcademicBackBtn from '../AcademicBackBtn';
const InnoProgram = () => {
    const [programInfo, setProgramInfo] = useState(null);
    useEffect(() => {
        client
            .query({
                query: queries.innoProgModalInfo,
            })
            .then((response) => {
                const programDoc = response.data.allInno_programmes.edges[0].node;
                setProgramInfo(programDoc);
                window.scrollTo(0, 0)
            })
            .catch((error) => {
                console.error(error);
            });
    });
    return (
        <>
            <section style={{ backgroundImage: 'url(' + programInfo?.section_bg?.url + ')' }} className=" pattern innovation-pattern ">
                <div className="container">
                    <AcademicBackBtn />
                    <h3 className="subtitle pt-0 pb-1">{programInfo?.title[0]?.text}</h3>
                    <p className="pt-2 body-text">{programInfo?.description[0]?.text} <br /></p>
                    <ul className="ps-4">
                        {programInfo?.description_list?.map((listInfo, index) => <li>{listInfo.info[0]?.text}</li>)}

                    </ul>
                    <p className=" pb-3 body-text">{programInfo?.description_footer[0]?.text}</p>
                    <div className="row g-2 ">
                        {programInfo?.card?.map((info, index) =>
                            <AcademicCommoncrd
                                key={index + 1}
                                info={info}
                                crdHight={640}
                                XLHight={520}
                                innoProgram={true}
                            >

                            </AcademicCommoncrd>)
                        }

                    </div>
                    <div className=" py-4">
                        <div className="nav  nav-tabs" id="nav-tab" role="tablist">
                            <button
                                className="nav-link border-0 active primary-text"
                                id="important-date-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#important-date"
                                type="button"
                                role="tab"
                                aria-controls="important-date"
                                aria-selected="true"
                            >
                                {programInfo?.date_text[0]?.text}
                            </button>

                        </div>
                    </div>
                    <div className="tab-content pb-2" id="nav-tabContent">
                        <div
                            className="tab-pane fade show  active "
                            id="important-date"
                            role="tabpanel"
                            aria-labelledby="important-date-tab"
                        >
                            {programInfo?.date_info?.map((date, index) => <ImportantDate key={index + 1} linkable={true} sl={index + 1} date_info={date} />)}
                            {programInfo?.announcement?.map((date, index) => <ImportantDate key={index + 4} sl={index + 4} date_info={date} />)}

                        </div>
                    </div>
                    <div className="application-process">
                        <h5 className="appication-title">{programInfo?.sub_title[0]?.text}</h5>

                        <p className=" body-text">{programInfo?.sub_descript[0]?.text}</p>
                        <p className="body-text" >{programInfo?.email_text[0]?.text} <a href=""> {programInfo?.email[0]?.text}</a> </p>
                    </div>
                </div>
            </section>
        </>

    );
};

export default InnoProgram;




